/**
 * Registry table ids for the Nostos v3 external API (`Query.NostosExternal.getData`).
 *
 * The v3 API addresses tables by opaque registry id only (table-name resolution is
 * disabled for external callers as a privacy boundary). Each id below maps the legacy
 * `externallyAccessibleNostos.v1` `job_name` to its row in the Nostos table registry.
 */
export const NOSTOS_EXTERNAL_TABLE_IDS = {
  portfolio_projects: '9',
  portfolio_projects_by_slug: '39',
  megamenu_popular_terms_by_domain: '47',
  megamenu_nostos_job: '66',
  enterprise_products_with_labs: '68',
  browse_relevant_skills_by_domain: '77',
  product_metrics: '112',
  prod_search_queries_to_entities: '118',
  articles_estimated_read_time: '120',
  recent_pathway_completers: '144',
} as const;

export type NostosExternalTable = keyof typeof NOSTOS_EXTERNAL_TABLE_IDS;
